export default "__VITE_ASSET__70adc678__"